export default "__VITE_ASSET__DlpUq6K7__"